import { createContext, useContext, type ReactNode } from 'react';

import { getRuntimeConfig } from './load-config';
import type { RuntimeConfig } from './schema';

const ConfigContext = createContext<RuntimeConfig | undefined>(undefined);

/** Injeta uma config (testes, catálogo `/dev`). Em produção basta o `loadRuntimeConfig` do boot. */
export function ConfigProvider({ config, children }: { config: RuntimeConfig; children: ReactNode }) {
  return <ConfigContext value={config}>{children}</ConfigContext>;
}

/** A config de runtime do domínio. É imutável depois do boot, então não re-renderiza. */
export function useConfig(): RuntimeConfig {
  return useContext(ConfigContext) ?? getRuntimeConfig();
}
